/* Galaxy: tidy the address bar so links copied or shared from a phone are short.
   2026-10-22. Strips Shopify/Google tracking parameters (e.g. _su_rec, _pos, _sid,
   pr_rec_id, srsltid) from the URL with history.replaceState. Runs 1.5s after
   the page has fully loaded, so Shopify analytics and GTM have already read them.
   Does NOT touch utm_*, gclid, fbclid (ad attribution) or real parameters such
   as q, page, sort_by, filter.*, variant. No reload, no navigation. */
(function () {
  if (window.__gxCleanUrl) return;
  window.__gxCleanUrl = 1;
  var DROP = ['_su_rec', '_pos', '_psq', '_psid', '_ss', '_sid', '_v', '_fid', 'srsltid'];
  var DROP_PREFIX = ['pr_', '_su'];
  function clean() {
    try {
      if (!window.history || !history.replaceState || !window.URL) return;
      var u = new URL(window.location.href);
      var keys = [];
      u.searchParams.forEach(function (v, k) { keys.push(k); });
      var changed = false;
      keys.forEach(function (k) {
        var hit = DROP.indexOf(k) >= 0 || DROP_PREFIX.some(function (p) { return k.indexOf(p) === 0; });
        if (hit) { u.searchParams.delete(k); changed = true; }
      });
      if (!changed) return;
      var qs = u.searchParams.toString();
      history.replaceState(history.state, '', u.pathname + (qs ? '?' + qs : '') + u.hash);
    } catch (e) {}
  }
  function later() { setTimeout(clean, 1500); }
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later);
})();
